import { Icon } from '@chakra-ui/react';
import type { JSX, ReactNode } from 'react';

import type { NovaIconGlyphProps } from 'components/ui/novaIcon/novaIconTypes';

export type TripletGlyphSlots = {
  /** 16px kit — Figma S. */
  s: () => ReactNode;
  /** 18px kit — Figma M. */
  m: () => ReactNode;
  /** 24px kit — Figma L. */
  l: () => ReactNode;
};

/**
 * Factory for glyphs: distinct SVG markup per Figma S/M/L (fill or outline).
 * `glyphSize` defaults to `m` when omitted (same as {@link NovaIcon}).
 */
export const createTripletGlyphIcon = (
  displayName: string,
  slots: TripletGlyphSlots
): ((props: NovaIconGlyphProps) => JSX.Element) => {
  const TripletGlyph = ({ glyphSize, ...rest }: NovaIconGlyphProps): JSX.Element => {
    let inner: ReactNode;
    switch (glyphSize) {
      case 's':
        inner = slots.s();
        break;
      case 'l':
        inner = slots.l();
        break;
      case 'm':
      default:
        inner = slots.m();
        break;
    }

    return <Icon {...rest}>{inner}</Icon>;
  };

  TripletGlyph.displayName = displayName;
  return TripletGlyph;
};
